import { jsx as _jsx } from "react/jsx-runtime";
import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import UIImage from 'UIComponents/image/UIImage';
import imageUrls from '../images/imageUrls';
import styled from 'styled-components';
import { devices } from '../styles/viewports.styles';
const StyledHubSpotForXLogo = styled(UIImage).withConfig({
  displayName: "HubSpotForXLogo__StyledHubSpotForXLogo",
  componentId: "d1i5o0-0"
})(["display:none;@media ", "{display:inline-block;}"], devices.desktop);
const flowToImage = {
  [Flow.HubspotForNonprofits]: imageUrls.hubSpotForNonprofitsLogo,
  [Flow.HubspotForStartups]: imageUrls.hubSpotForStartupsLogo
};
export const HubSpotForXLogo = () => {
  const flowKey = getFlowKey();
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(StyledHubSpotForXLogo, {
      alt: flowKey,
      height: 40,
      responsive: false,
      src: flowToImage[flowKey]
    })
  });
};